import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "unit"];

  connect() {
    console.log("Controller connected");
    if (this.selectTarget.value) {
      console.log("Initial value:", this.selectTarget.value);
      this.updateUnit();
    }
  }

  updateUnit() {
    const selectedOption = this.selectTarget.selectedOptions[0];
    console.log("Selected option:", selectedOption);
    const unit = selectedOption.dataset.unit;
    console.log("Unit:", unit);
    if (unit) {
      this.unitTarget.textContent = unit;
    }
  }
}
